import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";

function DocumentsCard({ link, title }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="cursor-pointer w-44 bg-neutral-800 rounded-lg p-4 flex flex-col items-center 
                 transition transform hover:-translate-y-1 hover:shadow-lg 
                 hover:bg-neutral-700 active:scale-95"    >
      <div className="w-12 h-12 mb-2 flex items-center justify-center rounded-full bg-neutral-600">
        <FontAwesomeIcon icon={faFileAlt} className="text-white text-2xl" />
      </div>
      <p className="text-sm font-semibold text-center text-white truncate">
        {title}
      </p>
    </a>
  );
}

export default DocumentsCard;
